module.exports = __webpack_public_path__ + "img/44_13.47f14407.png";